import classNames from 'classnames';
import styles from './BaseButton.module.scss';
import { Loader } from '../loader';

export interface BaseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  isLoading?: boolean;
}

export function BaseButton(props: BaseButtonProps): React.ReactElement {
  const { children, className, isLoading, disabled, ...restProps } = props;

  return (
    <button
      {...restProps}
      className={classNames(styles.baseButton, className)}
      disabled={isLoading || disabled}
    >
      {isLoading && <Loader size={20} />}
      {!isLoading && children}
    </button>
  );
}
